import axios from "axios";
import { CurrentUser } from "../Helpers/CurrentUser";

export const SpeedReport = async (startDate, endDate) => {
    return axios.post(process.env.REACT_APP_SERVER_URL + "/reporting/speedreport", {
        startDate,
        endDate
    }, {
        headers: {
            "Authorization": CurrentUser.getToken()
        },
        responseType: 'blob'
    });
}

export const UserReport = async() => {
        return axios.post(process.env.REACT_APP_SERVER_URL + "/reporting/userreport", {}, {
        headers: {
            "Authorization": CurrentUser.getToken()
        },
        responseType: 'blob'
    });
}